module.exports = __webpack_public_path__ + "img/f1e44ec.jpg";